<template>
  <div class="announceDetail">
    <v-container fluid>
      <v-container class="pa-0">
        <v-breadcrumbs :items="breadItems" divider="/"></v-breadcrumbs>
      </v-container>
      <v-container class="px-12">
        <v-row class="mb-6">
          <v-col
            cols="12"
            class="ct-text-subtitle ct-text-bolder mb-0 d-flex justify-center align-center"
          >
            <!-- <div>
            <v-img
              :src="require('@/assets/images/book/book_icon.svg')"
              contain
              class="mx-3"
              height="29"
              width="25"
            />
          </div> -->
            <span class="card-title" style="display:inline-block">{{
              item.title
            }}</span>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col
            cols="10"
            class="mb-0 d-flex justify-sm-space-around justify-md-space-between align-center flex-wrap"
          >
            <div
              class="ma-1 categoryItem"
              style="width:150px;"
              :style="{
                backgroundColor: SYS.setCategoryBgColor(item.subcategory)
              }"
            >
              {{ SYS.setCategory(item.subcategory) }}
            </div>
            <div v-if="item.important" class="ma-1 importantChip">
              精選
            </div>
            <v-spacer />
            <div class="grey--text">
              公告日期：{{ TOOL.setDateString(item.onlineDate) }}
            </div>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col cols="10">
            <v-divider />
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col cols="10" lg="8">
            <v-container>
              <div
                class="content-wrapper"
                v-html="TOOL.replaceUnitToRem(item.content)"
              ></div>
            </v-container>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center white">
          <v-col cols="9">
            <PhotoList :item="item" :topic="item.title" />
          </v-col>
        </v-row>
        <v-row
          class="d-flex justify-center white"
          v-if="!(item.file == null || typeof item.file == 'undefined')"
        >
          <v-col cols="10" lg="8">
            <FileList :item="item" />
          </v-col>
        </v-row>
        <v-row class="white">
          <v-col class="my-6 d-flex justify-center align-center mx-auto">
            <ListBack />
          </v-col>
        </v-row>
        <NextList :list="list" :idx="idx" @item="setItem" @idx="setIdx" />
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import NextList from "@/components/ui/detailComponent/NextList.vue";
import FileList from "@/components/ui/detailComponent/FileList.vue";
import PhotoList from "@/components/ui/detailComponent/PhotoList.vue";
import ListBack from "@/components/ui/detailComponent/ListBack.vue";
export default {
  components: {
    Footer,
    NextList,
    FileList,
    PhotoList,
    ListBack
  },
  data() {
    return {
      idx: 0,
      list: [],
      breadItems: [
        {
          text: "最新消息",
          disabled: false,
          to: "/Announce/"
        }
        // {
        //   text: "this.item.schoolCounty + this.item.schoolName",
        //   disabled: true,
        //   href: "breadcrumbs_link_2"
        // }
      ],
      item: {
        category: 1,
        title: "標題",
        onlineDate: Date.now(),
        content: "內容"
      }
    };
  },
  watch: {
    item() {
      this.breadItems = [
        {
          text: "最新消息",
          disabled: false,
          to: "/Announce/"
        }
      ];
      this.breadItems.push({
        text: this.item.title,
        disabled: true,
        href: "breadcrumbs_link_1"
      });
      document.title += "-" + this.item.title;
    }
  },
  mounted() {
    if (typeof this.$route.params.item !== "undefined") {
      this.item = this.$route.params.item;
    }
    if (typeof this.$route.query.idx !== "undefined") {
      this.idx = this.$route.query.idx;
      this.$store.dispatch("getAnnounceList").then(() => {
        this.list = this.$store.state.announce.announceList;
        if (typeof this.$route.query.name !== "undefined") {
          let target = this.list.findIndex(
            p => p.Sno == this.$route.query.name
          );
          if (target >= 0) {
            this.idx = target;
          }
        }
        this.item = this.list[this.idx];
        this.breadItems.push({
          text: this.item.title,
          disabled: true,
          href: "breadcrumbs_link_1"
        });
      });
    }
  },
  computed: {
    cTitleImg() {
      return require("@/assets/images/temp/temp_announce_item.png");
    }
  },
  methods: {
    setItem(val) {
      this.item = val;
    },
    setIdx(val) {
      this.idx = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.announceDetail {
  background-color: #f6edd9;
}
// p:before {
//   content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
// }
</style>
